import { render } from "./RatingForm.vue?vue&type=template&id=614ffaa6&scoped=true&ts=true"
import script from "./RatingForm.vue?vue&type=script&lang=ts"
export * from "./RatingForm.vue?vue&type=script&lang=ts"

import "./RatingForm.vue?vue&type=style&index=0&id=614ffaa6&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614ffaa6"]])

export default __exports__